module.exports = __webpack_public_path__ + "static/media/sfc.928f59cb.svg";